import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import { FragmentMessages } from "../../common/fragment-messages";
import FumbleRecoveredByPositionPref from "./position-pref/fumble-recovered-by-position-pref";
import FootballState from "../state/football-state";
import PatFumbleRecoveredByPositionPref from "./position-pref/pat-fumble-recovered-by-position-pref";

export default class FumbleRecovered extends Fragment {
    constructor(recoveredBy, recoveredAt) {
        super();
        this.recoveredBy = recoveredBy;
        this.recoveredAt = recoveredAt;
        this.requiredData = [
            {
                name: "recoveredBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => false,
                displayName: "Recovered By",
                title: (team) => `Recovered By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true,
                positionPref: (play) =>
                    play.historyContains(FootballState.PatTry)
                        ? new PatFumbleRecoveredByPositionPref(
                              play,
                              this
                          ).resolve()
                        : new FumbleRecoveredByPositionPref(
                              play,
                              this
                          ).resolve()
            },
            {
                name: "recoveredAt",
                type: FragmentDataType.FieldPosition,
                displayName: "Recovered At",
                title: "At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                showEndZoneYards: (gameConfig) =>
                    gameConfig.general.includeEndZoneYardage
            }
        ];
    }

    getFieldPosition() {
        return this.recoveredAt;
    }

    getFragmentTeamId() {
        return this.recoveredBy?.teamId;
    }

    changesPossession(currentPossessionId) {
        return this.recoveredBy?.teamId != currentPossessionId;
    }

    dirtiesPlaySequence(fragment) {
        return (
            this.recoveredBy &&
            this.recoveredBy.teamId !== fragment.recoveredBy?.teamId
        );
    }

    getPlayers() {
        return [this.recoveredBy];
    }

    summarize(summaryContext, stringifier) {
        if (this.recoveredBy) {
            const fieldPosition = stringifier.niceFieldPosition(
                summaryContext.gameConfig.general.fieldLength,
                summaryContext.fieldPosition,
                summaryContext.homeTeam?.abbrName,
                summaryContext.awayTeam?.abbrName
            );
            const message = `to ${fieldPosition}, recovered by ${stringifier.firstInitial(
                this.recoveredBy
            )}`;

            return new FragmentSummary(message);
        } else {
            return new FragmentSummary("");
        }
    }

    updateSummaryContext(summaryContext) {
        if (this.recoveredBy) {
            if (
                this.recoveredBy.teamId !==
                summaryContext.playerInPossession?.teamId
            ) {
                summaryContext.homeTeamHasPossession =
                    !summaryContext.homeTeamHasPossession;
            }

            if (this.recoveredAt || this.recoveredAt === 0) {
                summaryContext.fieldPosition = this.recoveredAt;
            }
            summaryContext.playerInPossession = this.recoveredBy;
        }
    }

    toJSON() {
        return {
            ...super.toJSON(),
            recoveredBy: playerReducer(this.recoveredBy)
        };
    }
}
